import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  year: number | undefined;
  ngOnInit(): void {
    this.year = (new Date()).getFullYear();
  }
}
